<div class="modal-header">
  <h5 class="modal-title">{{roleObj.heading}}</h5>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  <div class="overflow-x mt-3" style="width: 100%;">
    <div class="row">
      <div class="col-lg-3">
        <label class="control-label">Role Title</label>
      </div>
      <div class="col-lg-9">
        <input type="text" [(ngModel)]="roleObj.title" class="form-control form-control-sm" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm bg-g-lightGreen" disabled="{{isDisabled}}" [mat-dialog-close]="roleObj"
    cdkFocusInitial>Save</button>
</div>